import React, { useState, useEffect } from "react";
import { HashRouter, Route, Switch } from "react-router-dom";
import ErrorPage from "./components/ErrorPage";
// import { BrowserRouter } from "react-router-dom";
import Home from "./components/Home/Home";
import AskAnExpert from "./components/QAndA/AskAnExpert/AskAnExpert";
import CreateKnowledge from "./components/Knowledge/CreateKnowledge/CreateKnowledge";
import KnowledgeByMe from "./components/Knowledge/KnowledgeByMe";
import QueAnsByMe from "./components/QAndA/QueAnsByMe";
import QuestionsForMe from "./components/QAndA/QuestionsForMe";
import Bookmarks from "./common/Bookmarks";
import QueByMe from "./components/QAndA/QueByMe";
import ShowDetails from "./common/ShowDetails/ShowDetails";
import UsefulLinks from "./components/UsefulLinks/UsefulLinks";
import Search from "./common/Search/Search";
import Guidelines from "./components/Guidelines";
// import Analytics from './components/Analytics';
import AllStories from "./components/Home/AllStories";
import Calandar from "./components/Calandar/Calandar";

import { useSelector } from "react-redux";
import VideoRec from "./components/Knowledge/CreateKnowledge/VideoRec";
import AudioRec from "./components/Knowledge/CreateKnowledge/AudioRec";
import AggregateMaster from "./Pages/Masters/AggregateMaster/AggregateMaster";
import CalendarEventMaster from "./Pages/Masters/CalendarEventMaster/CalendarEventMaster";
import EventGalleryDashboard from "./Pages/Masters/EventGallery/EventGalleryDashboard";
import EventGalleryEdit from "./Pages/Masters/EventGallery/EventGalleryEdit";
import AggregateMasterEdit from "./Pages/Masters/AggregateMaster/AggregateMasterEdit";
import CalendarEventEdit from "./Pages/Masters/CalendarEventMaster/CalendarEventMasterEdit";
import HashtagMaster from "./Pages/Masters/HashtagMaster/HashtagMaster";
import HashtagMasterEdit from "./Pages/Masters/HashtagMaster/HashtagMasterEdit";
import PlatformMaster from "./Pages/Masters/PlatformMaster/PlatformMaster";
import PlatformMasterEdit from "./Pages/Masters/PlatformMaster/PlatformMasterEdit";
import BadgeMaster from "./Pages/Masters/BadgeMaster/BadgeMaster";
import BadgeMasterEdit from "./Pages/Masters/BadgeMaster/BadgeMasterEdit";
import KnowledgeBaseMaster from "./Pages/Masters/KnowledgeBaseMaster/KnowledgeBaseMaster";
import KnowledgeBaseMasterEdit from "./Pages/Masters/KnowledgeBaseMaster/KnowledgeBaseMasterEdit";
import UserRoleMaster from "./Pages/Masters/UserRoleMaster/UserRoleMaster";
import UserRoleMasterEdit from "./Pages/Masters/UserRoleMaster/UserRoleMasterEdit";
import EventGallery2 from "./components/EventGallery/EventGallery2";
import ViewMoreImage2 from "./components/EventGallery/ViewMoreImage2";
import TickerMaster from "./Pages/Masters/TickerMaster/TickerMaster";
import TickerMasterEdit from "./Pages/Masters/TickerMaster/TickerMasterEdit";
import AppVersionMaster from "./Pages/Masters/AppVersionMaster/AppVersionMaster";
import AppVersionMasterEdit from "./Pages/Masters/AppVersionMaster/AppVersionMasterEdit";
import UesfulLinkMaster from "./Pages/Masters/UesfulLinkMaster/UesfulLinkMaster";
import UesfulLinkMasterEdit from "./Pages/Masters/UesfulLinkMaster/UesfulLinkMasterEdit";
import GuidelinesMaster from "./Pages/Masters/GuidelinesMaster/GuidelinesMaster";
import GuidelinesMasterEdit from "./Pages/Masters/GuidelinesMaster/GuidelinesMasterEdit";
import KnowledgeBase from "./components/Knowledge/KnowledgeBase";
import KnowldegeBaseaId from "./components/Knowledge/KnowledgeBaseByid";
import KCBulkUploadDocument from "./components/Knowledge/CreateKnowledge/KCBulkUploadDocument";
import BulkUploadDocument from "./components/Knowledge/CreateKnowledge/BulkUploadDocument";
import BulkUploadDocumentEdit from "./components/Knowledge/CreateKnowledge/BulkUploadDocumentEdit";
import DashboardEdit from "./Pages/Dashboard/DashboardEdit";
import Dashboard from "./Pages/Dashboard/Dashboard";
import Report from "./Pages/Report/Report";
import ProfileNew from "./components/Profile/ProfileNew";
import LoginV2 from "./components/Login/LoginV2";
import Protected from "./helpers/PageAccess/Protected";
import { getContextFromLocalStorage } from "./helpers/Context/Context";

function AppRouter() {
  const { fileName, thumbnailId, videoId, transcription, videoBlob } =
    useSelector((state) => state.uploadVid);
  const context = getContextFromLocalStorage();
  console.log("🚀 ~ file: AppRouter.js:67 ~ AppRouter ~ context:", context);
  const {
    audioFileName,
    thumbnailId: audioThumbnailId,
    audioId,
    transcription: audioTranscription,
    audioBlob,
    audioDetails,
  } = useSelector((state) => state.uploadAud);
  const [showNextModal, openNextModal] = useState(false);
  const [showNextModalAudio, openNextModalAudio] = useState(false);

  // const [,setModal] = useState(true);

  //console.log("sh---", showNextModal);
  //console.log("sh-m odel audio--", showNextModalAudio);

  useEffect(() => {
    const selector = document.querySelector("#close-notification-button");
    const isOpenModal = videoId ? true : false;
    //console.log("-----", isOpenModal);
    isOpenModal && selector.click();
    openNextModal(isOpenModal);
  }, [videoId, fileName]);

  useEffect(() => {
    const selector = document.querySelector("#close-notification-button");
    const isOpenModal = audioId ? true : false;
    isOpenModal && selector.click();
    openNextModalAudio(isOpenModal);
  }, [audioId, audioFileName]);

  const handleVideoModal = (value) => {
    openNextModal(value);
  };

  const handleAudioModal = (value) => {
    openNextModalAudio(value);
  };

  return (
    <main>
      {/* <Route path={"/GcpFileUploadComponent"} exact={true} component={GcpFileUploadComponent} /> */}
      <HashRouter>
        <Switch>
          <Route path={"/"} exact={true} component={LoginV2} />
          <Route path={"/home"} exact={true} component={Home} />
          <Route path={"/ask-an-expert"} exact={true} component={AskAnExpert} />
          <Route
            path={"/calendarEvent-master"}
            exact={true}
            // component={CalendarEventMaster}
            component={() => (
              <Protected permittedPages={"CalenderEvent"} pageContext={context}>
                <CalendarEventMaster />
              </Protected>
            )}
          />
          <Route
            path={"/calendarEvent-master/edit"}
            exact={true}
            // component={CalendarEventEdit}
            component={() => (
              <Protected
                permittedPages={"CalenderEventEdit"}
                pageContext={context}
              >
                <CalendarEventEdit />
              </Protected>
            )}
          />
          <Route
            path={"/aggregate-master"}
            exact={true}
            // component={AggregateMaster}
            component={() => (
              <Protected
                permittedPages={"AggregateMaster"}
                pageContext={context}
              >
                <AggregateMaster />
              </Protected>
            )}
          />
          <Route
            path={"/aggregate-master/edit"}
            exact={true}
            // component={AggregateMasterEdit}
            component={() => (
              <Protected
                permittedPages={"AggregateMasterEdit"}
                pageContext={context}
              >
                <AggregateMasterEdit />
              </Protected>
            )}
          />
          <Route
            path={"/hashtag-master"}
            exact={true}
            // component={HashtagMaster}
            component={() => (
              <Protected permittedPages={"HashtagMaster"} pageContext={context}>
                <HashtagMaster />
              </Protected>
            )}
          />
          <Route
            path={"/hashtag-master/edit"}
            exact={true}
            // component={HashtagMasterEdit}
            component={() => (
              <Protected
                permittedPages={"HashtagMasterEdit"}
                pageContext={context}
              >
                <HashtagMasterEdit />
              </Protected>
            )}
          />
          <Route
            path={"/platform-master"}
            exact={true}
            // component={PlatformMaster}
            component={() => (
              <Protected
                permittedPages={"PlatformMaster"}
                pageContext={context}
              >
                <PlatformMaster />
              </Protected>
            )}
          />
          <Route
            path={"/platform-master/edit"}
            exact={true}
            // component={PlatformMasterEdit}
            component={() => (
              <Protected
                permittedPages={"PlatformMasterEdit"}
                pageContext={context}
              >
                <PlatformMasterEdit />
              </Protected>
            )}
          />

          <Route
            path={"/event-gallery-master"}
            exact={true}
            // component={EventGalleryDashboard}
            component={() => (
              <Protected permittedPages={"EventGallery"} pageContext={context}>
                <EventGalleryDashboard />
              </Protected>
            )}
          />
          <Route
            path={"/event-gallery-master/edit"}
            exact={true}
            // component={EventGalleryEdit}
            component={() => (
              <Protected
                permittedPages={"EventGalleryEdit"}
                pageContext={context}
              >
                <EventGalleryEdit />
              </Protected>
            )}
          />
          <Route
            path={"/badge-master"}
            exact={true}
            // component={BadgeMaster}
            component={() => (
              <Protected permittedPages={"BadgeMaster"} pageContext={context}>
                <BadgeMaster />
              </Protected>
            )}
          />
          <Route
            path={"/badge-master/edit"}
            exact={true}
            // component={BadgeMasterEdit}
            component={() => (
              <Protected
                permittedPages={"BadgeMasterEdit"}
                pageContext={context}
              >
                <BadgeMasterEdit />
              </Protected>
            )}
          />
          <Route
            path={"/knowledgebase-master"}
            exact={true}
            // component={KnowledgeBaseMaster}
            component={() => (
              <Protected
                permittedPages={"KnowledgebaseMaster"}
                pageContext={context}
              >
                <KnowledgeBaseMaster />
              </Protected>
            )}
          />
          <Route
            path={"/knowledgebase-master/edit"}
            exact={true}
            // component={KnowledgeBaseMasterEdit}
            component={() => (
              <Protected
                permittedPages={"KnowledgebaseMasterEdit"}
                pageContext={context}
              >
                <KnowledgeBaseMasterEdit />
              </Protected>
            )}
          />
          <Route
            path={"/userrole-master"}
            exact={true}
            // component={UserRoleMaster}
            component={() => (
              <Protected
                permittedPages={"UserroleMaster"}
                pageContext={context}
              >
                <UserRoleMaster />
              </Protected>
            )}
          />
          <Route
            path={"/userrole-master/edit"}
            exact={true}
            // component={UserRoleMasterEdit}
            component={() => (
              <Protected
                permittedPages={"UserroleMasterEdit"}
                pageContext={context}
              >
                <UserRoleMasterEdit />
              </Protected>
            )}
          />
          <Route
            path={"/appversion-master"}
            exact={true}
            // component={AppVersionMaster}
            component={() => (
              <Protected
                permittedPages={"AppVersionMaster"}
                pageContext={context}
              >
                <AppVersionMaster />
              </Protected>
            )}
          />
          <Route
            path={"/appversion-master/edit"}
            exact={true}
            // component={AppVersionMasterEdit}
            component={() => (
              <Protected
                permittedPages={"AppVersionMasterEdit"}
                pageContext={context}
              >
                <AppVersionMasterEdit />
              </Protected>
            )}
          />
          <Route
            path={"/ticker-master"}
            exact={true}
            // component={TickerMaster}
            component={() => (
              <Protected permittedPages={"TickerMaster"} pageContext={context}>
                <TickerMaster />
              </Protected>
            )}
          />
          <Route
            path={"/ticker-master/edit"}
            exact={true}
            // component={TickerMasterEdit}
            component={() => (
              <Protected
                permittedPages={"TickerMasterEdit"}
                pageContext={context}
              >
                <TickerMasterEdit />
              </Protected>
            )}
          />
          <Route
            path={"/usefullink-master"}
            exact={true}
            // component={UesfulLinkMaster}
            component={() => (
              <Protected permittedPages={"UserfulLink"} pageContext={context}>
                <UesfulLinkMaster />
              </Protected>
            )}
          />
          <Route
            path={"/usefullink-master/edit"}
            exact={true}
            // component={UesfulLinkMasterEdit}
            component={() => (
              <Protected
                permittedPages={"UserfulLinkEdit"}
                pageContext={context}
              >
                <UesfulLinkMasterEdit />
              </Protected>
            )}
          />
          <Route
            path={"/guidelines-master"}
            exact={true}
            // component={GuidelinesMaster}
            component={() => (
              <Protected permittedPages={"Guidelines"} pageContext={context}>
                <GuidelinesMaster />
              </Protected>
            )}
          />
          <Route
            path={"/guidelines-master/edit"}
            exact={true}
            // component={GuidelinesMasterEdit}
            component={() => (
              <Protected
                permittedPages={"GuidelinesEdit"}
                pageContext={context}
              >
                <GuidelinesMasterEdit />
              </Protected>
            )}
          />
          <Route
            path={"/knowledge-created-by-me"}
            exact={true}
            component={KnowledgeByMe}
          />
          <Route
            path={"/questions-answered-by-me"}
            exact={true}
            component={QueAnsByMe}
          />
          <Route
            path={"/questions-asked-by-me"}
            exact={true}
            component={QueByMe}
          />
          <Route
            path={"/questions-for-me"}
            exact={true}
            component={QuestionsForMe}
          />
          <Route
            path={"/create-knowledge"}
            exact={true}
            component={CreateKnowledge}
          />
          <Route
            path={"/bulk-upload-document"}
            exact={true}
            // component={BulkUploadDocument}
            component={() => (
              <Protected
                permittedPages={"BulkUploadDocument"}
                pageContext={context}
              >
                <BulkUploadDocument />
              </Protected>
            )}
          />
          <Route
            path={"/bulk-upload-document/edit"}
            exact={true}
            // component={BulkUploadDocumentEdit}
            component={() => (
              <Protected
                permittedPages={"BulkUploadDocumentEdit"}
                pageContext={context}
              >
                <BulkUploadDocumentEdit />
              </Protected>
            )}
          />
          <Route
            path={"/kc-bulk-upload-document"}
            exact={true}
            // component={KCBulkUploadDocument}
            component={() => (
              <Protected
                permittedPages={"KCBulkUploadDocument"}
                pageContext={context}
              >
                <KCBulkUploadDocument />
              </Protected>
            )}
          />

          <Route
            path={"/dashboard"}
            exact={true}
            component={() => <Dashboard />}
          />
          <Route
            path={"/dashboard/edit"}
            exact={true}
            component={() => <DashboardEdit />}
          />

          <Route path={"/report"} exact={true} component={() => <Report />} />

          <Route path={"/all-stories"} exact={true} component={AllStories} />
          <Route path={"/bookmarks"} exact={true} component={Bookmarks} />
          <Route path={"/calendar"} exact={true} component={Calandar} />
          <Route path={"/knowledge"} exact={true} component={KnowledgeBase} />
          <Route
            path={"/knowledgeBase/:id"}
            exact={true}
            component={KnowldegeBaseaId}
          />
          <Route path={"/guidelines"} exact={true} component={Guidelines} />
          {/* <Route path={'/analytics'} exact = {true} component={Analytics}/> */}
          <Route path={"/usefull-links"} exact={true} component={UsefulLinks} />
          <Route
            path={"/eventgallery"}
            exact={true}
            component={EventGallery2}
          />
          {/* <Route path={'/eventgallery/:name'} component={ViewMoreImage} /> */}
          <Route path={"/eventgallery/:id"} component={ViewMoreImage2} />
          <Route
            path="/details"
            render={(props) => <ShowDetails {...props} />}
          />
          <Route path="/search" render={(props) => <Search {...props} />} />
          <Route path={"/profile"} exact={true} component={ProfileNew} />
          {/* Default:404 ROUTE */}
          <Route component={ErrorPage} />
        </Switch>
        {/* {type=== "video"} */}
        {showNextModal && (
          <VideoRec
            handleModal={handleVideoModal}
            videoBlob={videoBlob}
            transcription={transcription}
            fileName={fileName}
            videoId={videoId}
            thumbnailId={thumbnailId}
            transcriptionString={
              transcription && JSON.stringify({ transcript: transcription })
            }
          />
        )}
        {showNextModalAudio && (
          <AudioRec
            audioFileName={audioFileName}
            audioId={audioId}
            audioBlob={audioBlob}
            audioThumbnailId={audioThumbnailId}
            audioTranscription={audioTranscription}
            transcriptionString={
              audioTranscription &&
              JSON.stringify({ transcript: audioTranscription })
            }
            audioDetails={audioDetails}
            handleModal={handleAudioModal}
          />
        )}
      </HashRouter>
    </main>
  );
}
export default AppRouter;
